import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var AFSReportCard =
/*#__PURE__*/
function (_BaseData) {
  _inherits(AFSReportCard, _BaseData);

  function AFSReportCard() {
    _classCallCheck(this, AFSReportCard);

    return _possibleConstructorReturn(this, _getPrototypeOf(AFSReportCard).call(this, "AFSReportCard"));
  }

  _createClass(AFSReportCard, [{
    key: "GetByAFSId",
    value: function () {
      var _GetByAFSId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(afsId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByAFSId/").concat(afsId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByAFSId(_x) {
        return _GetByAFSId.apply(this, arguments);
      }

      return GetByAFSId;
    }()
  }, {
    key: "GetByPropertyAndYear",
    value: function () {
      var _GetByPropertyAndYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(propertyId, year) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByPropertyAndYear/").concat(propertyId, "/").concat(year)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetByPropertyAndYear(_x2, _x3) {
        return _GetByPropertyAndYear.apply(this, arguments);
      }

      return GetByPropertyAndYear;
    }()
  }, {
    key: "GetViewModelByAFSid",
    value: function () {
      var _GetViewModelByAFSid = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(afsId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/vm/").concat(afsId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetViewModelByAFSid(_x4) {
        return _GetViewModelByAFSid.apply(this, arguments);
      }

      return GetViewModelByAFSid;
    }()
  }, {
    key: "AFSHasNonCompliance",
    value: function () {
      var _AFSHasNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(afsId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/AFSHasNonCompliance/").concat(afsId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function AFSHasNonCompliance(_x5) {
        return _AFSHasNonCompliance.apply(this, arguments);
      }

      return AFSHasNonCompliance;
    }()
  }, {
    key: "GetBudgetVsAuditAmounts",
    value: function () {
      var _GetBudgetVsAuditAmounts = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(afsId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/vm/GetBudgetVsAuditAmounts/").concat(afsId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetBudgetVsAuditAmounts(_x6) {
        return _GetBudgetVsAuditAmounts.apply(this, arguments);
      }

      return GetBudgetVsAuditAmounts;
    }()
  }, {
    key: "Approve",
    value: function () {
      var _Approve = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(afsId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.put("/api/".concat(this._controller, "/Approve/").concat(afsId)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function Approve(_x7) {
        return _Approve.apply(this, arguments);
      }

      return Approve;
    }()
  }, {
    key: "Update2024AFSReportCard",
    value: function () {
      var _Update2024AFSReportCard = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.post("/api/".concat(this._controller, "/Update2024AFSReportCard")));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function Update2024AFSReportCard() {
        return _Update2024AFSReportCard.apply(this, arguments);
      }

      return Update2024AFSReportCard;
    }()
  }, {
    key: "CloseInNonCompliance",
    value: function () {
      var _CloseInNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(afsId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.put("/api/".concat(this._controller, "/CloseInNonCompliance/").concat(afsId)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function CloseInNonCompliance(_x8) {
        return _CloseInNonCompliance.apply(this, arguments);
      }

      return CloseInNonCompliance;
    }()
  }, {
    key: "CloseAFSNonCompliance",
    value: function () {
      var _CloseAFSNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(afsId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.put("/api/".concat(this._controller, "/CloseAFSNonCompliance/").concat(afsId)));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function CloseAFSNonCompliance(_x9) {
        return _CloseAFSNonCompliance.apply(this, arguments);
      }

      return CloseAFSNonCompliance;
    }()
  }, {
    key: "Reopen",
    value: function () {
      var _Reopen = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(afsId) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.put("/api/".concat(this._controller, "/Reopen/").concat(afsId)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function Reopen(_x10) {
        return _Reopen.apply(this, arguments);
      }

      return Reopen;
    }()
  }, {
    key: "StartReview",
    value: function () {
      var _StartReview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(afsId) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", axios.put("/api/".concat(this._controller, "/StartReview/").concat(afsId)));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function StartReview(_x11) {
        return _StartReview.apply(this, arguments);
      }

      return StartReview;
    }()
  }, {
    key: "GetAFSDCRHistory",
    value: function () {
      var _GetAFSDCRHistory = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(projectId) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", axios.get("/api/".concat(this._controller, "/GetAFSDCRHistory/").concat(projectId)));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function GetAFSDCRHistory(_x12) {
        return _GetAFSDCRHistory.apply(this, arguments);
      }

      return GetAFSDCRHistory;
    }()
  }]);

  return AFSReportCard;
}(BaseData);

export default new AFSReportCard();